module.exports = {
    DownloadableForms: {
        SUPER: [
            { name: 'Application Form', name_info: ' (Managed Accounts: To attach clients to a managed account, you must complete the e-Setup process online and obtain a pending account number, before you opt to download the form)', value: 'appForm', checked: false },
            { name: 'Identification Form Individuals and Sole Traders', value: 'individualKyc', checked: false },
            {
                name: 'Consolidating your super (FirstChoice Wholesale Personal Super)',
                value: 'consolidate',
                checked: false
            },
            { name: 'Colonial First State - Super Choice Fund Nomination Form', value: 'superChoice', checked: false },
            { name: 'Colonial First State Direct Debit Authority Form - form 2', value: 'dda2', checked: false },
            { name: 'Notice of intent to claim tax deduction', value: 'noticeOfIntent', checked: false },
            { name: 'Non lapsing death benefit nomination form', value: 'bindingDeath', checked: false },
            {
                name: 'FirstChoice Rollover of Insurance Cover Form (Internal)',
                value: 'rolloverInternal',
                checked: false
            },
            { name: 'Insurance application', value: 'insuranceApp', checked: false }
        ],
        PENSION: [
            { name: 'Application Form', name_info: ' (Managed Accounts: To attach clients to a managed account, you must complete the e-Setup process online and obtain a pending account number, before you opt to download the form)', value: 'appForm', checked: false },
            { name: 'Identification Form Individuals and Sole Traders', value: 'individualKyc', checked: false },
            {
                name: 'Consolidating your super (FirstChoice Wholesale Personal Super)',
                value: 'consolidate',
                checked: false
            },
            { name: 'Colonial First State Direct Debit Authority Form - form 2', value: 'dda2', checked: false },
            { name: 'Notice of intent to claim tax deduction', value: 'noticeOfIntent', checked: false },
            { name: 'TFN Declaration Form', value: 'tfnDeclaration', checked: false },
            { name: 'Non lapsing death benefit nomination form', value: 'bindingDeath', checked: false }
        ],
        INDIVIDUAL: [
            { name: 'Application Form', value: 'appForm', checked: false },
            { name: 'Identification Form Individuals and Sole Traders', value: 'individualKyc', checked: false },
            { name: 'Colonial First State Direct Debit Authority Form', value: 'dda2', checked: false }
        ],
        JOINT: [
            { name: 'Application Form', value: 'appForm', checked: false },
            { name: 'Identification Form Individuals and Sole Traders', value: 'individualKyc', checked: false },
            { name: 'Colonial First State Direct Debit Authority Form', value: 'dda5', checked: false }
        ],
        PARTNERSHIP: [
            { name: 'Application Form', value: 'appForm', checked: false },
            { name: 'Identification form Partnerships', value: 'partnershipKyc', checked: false },
            { name: 'Colonial First State Direct Debit Authority Form', value: 'dda2', checked: false }
        ],
        TRUST: [
            { name: 'Application Form', value: 'appForm', checked: false },
            { name: 'Identification form Regulated and Unregulated trust', value: 'trustKyc', checked: false },
            { name: 'Colonial First State Direct Debit Authority Form', value: 'dda2', checked: false }
        ],
        SMSF: [
            { name: 'Application Form', value: 'appForm', checked: false },
            {
                name: 'Identification form - Regulated Trusts and Trustees (Including Self Manged Super Funds)',
                value: 'smsfKyc',
                checked: false
            },
            { name: 'Colonial First State Direct Debit Authority Form', value: 'dda2', checked: false }
        ],
        COMPANY: [
            { name: 'Application Form', value: 'appForm', checked: false },
            { name: 'Identification form - Australian Companies', value: 'auCompanyKyc', checked: false },
            { name: 'Identification form - Foreign Companies', value: 'companyKyc', checked: false },
            { name: 'Colonial First State Direct Debit Authority Form', value: 'dda2', checked: false }
        ]
    },
    AdviserForms: {
        INDIVIDUAL2: 'onlineAdviserInd2',
        INDIVIDUAL5: 'onlineAdviserInd5',
        ORGANIZATION5: 'onlineAdviserOrg5'
    },
    Base64String: 'data:{contentType};base64,{base64}',
    ZipContentType: 'application/zip',
    PdfContentType: 'application/pdf',
    DefaultFileName: 'ApplicationForms.zip'
};


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./constants/DownloadConstants.js